import React from 'react';

import { useUserJobProspectsState, useUserJobProspectsActions } from './UserJobProspectsContext';
import { deleteJobProspect } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteJobProspectForm = () => {
  const state = useUserJobProspectsState();
  const { onResponse, onError, closeDeleteJobProspectModal } = useUserJobProspectsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleSubmit = () => {
    deleteJobProspect({
      userId: state?.userId,
      onResponse,
      onError,
      body: {
        authenticityToken,
        jobProspectId: state?.deleteJobProspectForm?.id,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to delete this job prospect?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeDeleteJobProspectModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Yes. Delete This Job Prospect.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteJobProspectForm;
